import React from 'react'
import { Select } from './Select'
import { UsageLimitType } from 'constant';

const usageLimitTypeOptions = Object.entries(UsageLimitType).map(([_, value]) =>
  Object.assign(
    {},
    {
      text: value.displayName,
      value: value.value,
    }
  )
);

type SelectUsageLimitTypeProps = {
  col: number
  name: string
  labelCol: number
  labelText: string
  setFieldValueOf?: (e: React.ChangeEvent<any>, setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void) => void
}

export const SelectUsageLimitType: React.FC<SelectUsageLimitTypeProps> = ({col, name = "usageLimitType", labelCol, labelText = "Usage Limit Type", setFieldValueOf}) => {
  return (
    <Select
      label={{ col: labelCol, text: labelText }}
      col={col}
      name={name}
      options={usageLimitTypeOptions}
      setFieldValueOf={setFieldValueOf}
    />
  )
}
